/**
 * Steadman / Australian BOM apparent temperature ("feels like") in shade.
 * Uses air temp (°C), relative humidity (%), and wind speed (km/h).
 * Returns null when inputs are incomplete.
 */
export function feelsLikeCelsius(
    tempC?: number | null,
    humidityPct?: number | null,
    windSpeedKmh?: number | null,
): number | null {
    if (tempC == null || humidityPct == null) return null;
    if (!Number.isFinite(tempC) || !Number.isFinite(humidityPct)) return null;

    const rh = Math.min(100, Math.max(0, humidityPct));
    const vapourPressure =
        (rh / 100) * 6.105 * Math.exp((17.27 * tempC) / (237.7 + tempC));
    const windMs =
        windSpeedKmh != null && Number.isFinite(windSpeedKmh)
            ? Math.max(0, windSpeedKmh) / 3.6
            : 0;

    const apparent = tempC + 0.33 * vapourPressure - 0.7 * windMs - 4;
    if (!Number.isFinite(apparent)) return null;
    return Math.round(apparent * 10) / 10;
}
